<template>
  <div class="row">
    <HomeNewsCount v-loading="isTrendLoading" :trendData="totalData" @onCardClick="onTrendCardClick" :color="'rgba(74, 183, 232, 0.48)'" :color1="'rgba(63, 171, 211, 0.24)'" :title="'舆情总数'" :count="total"  class="news-card"></HomeNewsCount>
    <HomeNewsCount v-loading="isNegativeLoading" :trendData="negativeData" @onCardClick="onNegativeCardClick" :color="'rgba(84, 206, 164, 0.48)'" :color1="'rgba(84, 206, 194, 0.24)'" :title="'负面舆情'" :count="negative" class="news-card"></HomeNewsCount>
    <HomeNewsCount v-loading="isPositiveLoading" :trendData="positiveData" @onCardClick="onPositiveCardClick" :color="'rgba(251, 94, 103, 0.48)'" :color1="'rgba(249, 124, 131, 0.24)'" :title="'正面舆情'" :count="positive" class="news-card"></HomeNewsCount>
    <HomeNewsCount v-loading="isNeutralLoading" :trendData="neutralData" @onCardClick="onNeutralCardClick" :color="'rgba(255, 255, 255, 0.14)'" :color1="'rgba(255, 255, 255, 0.14)'" :title="'中性舆情'" :count="neutral" class="news-card"></HomeNewsCount>
  </div>
</template>

<script>
import HomeNewsCount from '@/components/news-monitor/HomeNewsCount';
import authService from '@/services/authService';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      timer: null,
      isTrendLoading: false,
      isNegativeLoading: false,
      isPositiveLoading: false,
      isNeutralLoading: false,
      trendData: {},
      username: '',
      total: 0,
      positive: 0,
      neutral: 0,
      negative: 0,
      totalData: null,
      positiveData: null,
      negativeData: null,
      neutralData: null
    };
  },
  methods: {
    onTrendCardClick(res) {
      this.$router.push({ name: 'main-page', params: { type: res } });
    },
    onNegativeCardClick(res) {
      this.$router.push({ name: 'main-page', params: { type: res, filters: ['全部负面'] } });
    },
    onPositiveCardClick(res) {
      this.$router.push({ name: 'main-page', params: { type: res, filters: ['全部正面'] } });
    },
    onNeutralCardClick(res) {
      this.$router.push({ name: 'main-page', params: { type: res, filters: ['全部中性'] } });
    },
    getHomeOverviewDigital() {
      questionQuery.homeOverviewDigital(this.username).then(res => {
        this.negative = res.negative;
        this.neutral = res.neutral;
        this.positive = res.positive;
        this.total = res.total;
      });
    },
    getHomeOverviewChart() {
      this.isTrendLoading = true;
      questionQuery.homeOverviewChart(this.username, 'total').then(res => {
        this.isTrendLoading = false;
        this.totalData = res;
      });
      this.isNegativeLoading = true;
      questionQuery.homeOverviewChart(this.username, 'positive').then(res => {
        this.isNegativeLoading = false;
        this.positiveData = res;
      });
      this.isPositiveLoading = true;
      questionQuery.homeOverviewChart(this.username, 'negative').then(res => {
        this.isPositiveLoading = false;
        this.negativeData = res;
      });
      this.isNeutralLoading = true;
      questionQuery.homeOverviewChart(this.username, 'neutral').then(res => {
        this.isNeutralLoading = false;
        this.neutralData = res;
      });
    }
  },
  components: {
    HomeNewsCount
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getHomeOverviewDigital();
    this.getHomeOverviewChart();
    this.timer = window.setInterval(() => {
      this.getHomeOverviewDigital();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
  .news-card {
    flex: 1;
    margin-right: 1px;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.3);
    }
  }
    .news-card:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      overflow: hidden;
    }
    .news-card:last-child {
      margin-right: 0;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      overflow: hidden;
    }
</style>

